module.exports = __webpack_public_path__ + "img/base_activites_rando.ebce4ef2.svg";